<template>
<div class="colorFondo">
    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <h1>Pedidos</h1>
      <v-btn class="mt-2 success" to="/nuevoPedido">Nuevo Pedido</v-btn>
    </v-container>

    <v-card class="ma-3">
      <v-row class="mx-3 mt-3">
        <v-spacer></v-spacer>
        <v-text-field
        class="ma-3"
        v-model="buscador"
        label="Buscar"
        append-icon="mdi-magnify"
        single-line
        />

      </v-row>

      <v-data-table
      :headers="columnas"
      :items="pedidos"
      :search="buscador"
      :loading="cargando"
      item-class="allB"
      >
      
      <template v-slot:[`item.detallePedido`]="{ item }">
        <div>
          <ModalEditarPedido
          :infoPedido ="item"
          :key="item.PEDIDO_ID"/>
        </div>
      </template>

      <template slot="no-data">
        <v-alert class="my-2" :value="true" type="info" color="orange darken-1" >
          No se encontró información para mostrar.
        </v-alert>
      </template>
      </v-data-table>

      
    </v-card>
  </div>
  <!-- <div class="accordion" role="tablist" id="acordeon">
    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
    <h1>Pedidos</h1>
    <v-btn class="mt-2 success" to="/NuevoPedido">Nuevo pedido</v-btn>
    </v-container> -->
    <!-- <v-card class="ma-3">
      <v-row class="mx-3 mt-3">
        <v-spacer></v-spacer>
        <v-text-field
        class="ma-3"
        v-model="buscador"
        label="Buscar"
        append-icon="mdi-magnify"
        single-line
        />
      </v-row>

      <v-data-table
      :headers="columnas"
      :items="requisiciones"
      :search="buscador"
      :loading="cargando"
      item-class="allB"
      >
      
        <template v-slot:[`item.actionEditar`]="{ item }">
          <div>
            <ModalEditar :infoRequisicion ="item" :key="item.REQUISICION_ID" />
          </div>
        </template>

        <template v-slot:[`item.actionEliminar`]="{ item }">
          <div>
            <ModalEliminar
            :infoRequisicion ="item"
            @actualizarTabla ="obtenerRequisiciones"
            :key="item.REQUISICION_ID"/>
          </div>
        </template>

        <template slot="no-data">
          <v-alert class="my-2" :value="true" type="info" color="orange lighten-2" >
            No se encontro informacion para mostrar.
          </v-alert>
        </template>

      </v-data-table>

      
    </v-card> -->


    <!-- <accordion>
        <accordion-item v-for='pedido in pedidos' :key="pedido.FOLIO"> -->
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <!-- <template slot="accordion-trigger">
            <h3> {{pedido.FECHA}} - {{pedido.FOLIO}}</h3>
          </template> -->
          <!-- This slot will handle all the content that is passed to the accordion -->
          <!-- <template slot="accordion-content">
            <span> {{pedido.DESCRIPCION}} </span>
          </template>
        </accordion-item>
    </accordion>
    <app-accordion class="mb-8">
      <template v-slot:title>
        <span class="font-semibold text-xl">Accordion 2</span>
      </template>
      <template v-slot:content>
        <p>
          <b>Lorem</b>
          Información del proyecto
        </p>
      </template>
    </app-accordion>

  </div>  -->
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ModalEditarPedido from './Modals/ModalEditarPedido.vue'
export default {
  components: { ModalEditarPedido },

  data() {
    return {

      pedidos:[],

      buscador:"",
      cargando:false,

      columnas:[
        {text:"Folio",                  value:"FOLIO"},
        {text:"Bodega",                 value:"NOMBRE"},
        {text:"Descripcion",            value:"DESCRIPCION"},
        {text:"Fecha",                  value:"FECHA"},
        //{text:"Estatus",                value:"ESTATUS",  divider:true,},
        {text:"Ver Detalle",  value:"detallePedido"},
        {text:"Eliminar", sortable:false, value:"actionEliminar"},
      ],

    }
  },

    computed: {
    ...mapGetters(['getURLAPI','getFechaActual'])  
  },

  methods: {
    // ----------------------------------------------------------------------------
    async obtenerPedidos(){
      this.cargando = true;
      this.pedidos = (await axios.get(`${this.getURLAPI}/Pedidos/mostrarPedidos`)).data
      //console.log(this.pedido)
      this.cargando = false;      
    },

    // ----------------------------------------------------------------------------
    editarPedido( pedido ){
      this.pedido = pedido;
      this.mostrarModal = true;
    },

    // ----------------------------------------------------------------------------
    claseItem(item){
      if (!item) return
      return "mouse"
    },

  },

  created() {
    document.title = "Pedidos | Bombas y Suministros del Norte";
    this.obtenerPedidos();
  },
}

// import Accordion from "../../components/accordion";
// import AccordionItem from "../../components/accordion-item";
//import axios from 'axios';
//import { mapGetters } from 'vuex';
//import { mapGetters } from 'vuex'

//export default {
  // data(){
  //   return{
  //    pedidos:[],
  //    selectionOptions:{
  //      type: "Multiple"
  //    }
  //   }
  // },
  // computed: {
  //   ...mapGetters(['getURLAPI'])
  // },
  // name: "acordeon",
  // components: {Accordion,AccordionItem},
  //methods: {
    // ----------------------------------------------------------------------------
    // async obtenerPedidos(){
    //   this.cargando = true;
    //   this.pedidos = (await axios.get(`${this.getURLAPI}/Pedidos/mostrarPedidos`)).data
    //   console.log(this.pedidos)
    //   this.cargando = false;
    // },
  // },
  // created() {
  //   this.obtenerPedidos()
  // },
//}
</script>

<style>
/* #acordeon {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2182e4;
  margin-top: 60px;
} */
@media screen and (max-width : 425px){
  #mobil{
    font-size: small;
    word-break: inherit!important;
  }
}
.mouse{
  cursor: pointer!important;
}
</style>